/* ============================================================
   sahibaswholesale custom — Floating Reel Player v2.0
   File: assets/custom.js  (append to end of file)
   ============================================================ */

(function () {
  'use strict';

  /* ── GUARD: only run if reel URLs exist on this page ── */
  if (!window.sahibasReelUrls) return;

  /* Normalise: metafield list.url gives an array; single url gives a string */
  var urls = Array.isArray(window.sahibasReelUrls)
    ? window.sahibasReelUrls
    : [window.sahibasReelUrls];

  if (!urls.length) return;

  /* ── STATE ── */
  var currentIndex = 0;
  var autoAdvanceTimer = null;
  var AUTO_ADVANCE_MS = 8000; // advance mini reel every 8 s

  /* ── DOM REFS ── */
  var card        = document.getElementById('sahibas-reel-card');
  var miniVideo   = document.getElementById('sahibas-reel-mini');
  var closeBtn    = document.getElementById('sahibas-reel-close');
  var reopenBtn   = document.getElementById('sahibas-reel-reopen');
  var fullviewBtn = document.getElementById('sahibas-reel-fullview');
  var cardDots    = document.getElementById('sahibas-reel-dots');

  var modal       = document.getElementById('sahibas-reel-modal');
  var backdrop    = document.getElementById('sahibas-reel-backdrop');
  var fullVideo   = document.getElementById('sahibas-reel-full');
  var modalClose  = document.getElementById('sahibas-modal-close');
  var modalPrev   = document.getElementById('sahibas-modal-prev');
  var modalNext   = document.getElementById('sahibas-modal-next');
  var modalDots   = document.getElementById('sahibas-modal-dots');

  if (!card || !miniVideo || !modal || !fullVideo) return;

  /* ── BUILD DOTS ── */
  function buildDots(container, count) {
    container.innerHTML = '';
    if (count <= 1) return; // no dots needed for single reel
    for (var i = 0; i < count; i++) {
      var d = document.createElement('span');
      d.className = 'reel-dot' + (i === 0 ? ' active' : '');
      container.appendChild(d);
    }
  }

  function updateDots(container, index) {
    var dots = container.querySelectorAll('.reel-dot');
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i === index);
    });
  }

  buildDots(cardDots, urls.length);
  buildDots(modalDots, urls.length);

  /* ── NAV VISIBILITY ── */
  function updateModalNav() {
    if (urls.length <= 1) {
      modalPrev.classList.add('hidden');
      modalNext.classList.add('hidden');
    } else {
      modalPrev.classList.remove('hidden');
      modalNext.classList.remove('hidden');
    }
  }
  updateModalNav();

  /* ── LOAD & PLAY MINI VIDEO ── */
  function loadMini(index, autoplay) {
    miniVideo.src = urls[index];
    miniVideo.muted = true;
    miniVideo.load();
    if (autoplay !== false) {
      miniVideo.play().catch(function (e) {
        console.warn('[Sahibas Reel] Mini autoplay:', e);
      });
    }
    updateDots(cardDots, index);
  }

  /* ── AUTO-ADVANCE mini reel ── */
  function startAutoAdvance() {
    clearInterval(autoAdvanceTimer);
    if (urls.length <= 1) return;
    autoAdvanceTimer = setInterval(function () {
      currentIndex = (currentIndex + 1) % urls.length;
      loadMini(currentIndex);
    }, AUTO_ADVANCE_MS);
  }

  function stopAutoAdvance() {
    clearInterval(autoAdvanceTimer);
  }

  /* ── INIT mini reel ── */
  loadMini(0);
  startAutoAdvance();

  /* ── CLOSE CARD ── */
  closeBtn.addEventListener('click', function () {
    card.style.display = 'none';
    miniVideo.pause();
    stopAutoAdvance();
    reopenBtn.style.display = 'flex';
  });

  /* ── REOPEN CARD ── */
  reopenBtn.addEventListener('click', function () {
    card.style.display = 'flex';
    reopenBtn.style.display = 'none';
    loadMini(currentIndex);
    startAutoAdvance();
  });

  /* ── OPEN FULLSCREEN MODAL ── */
  function openModal(index) {
    currentIndex = index;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // Full video plays WITH sound (unmuted)
    fullVideo.src = urls[index];
    fullVideo.muted = false;
    fullVideo.load();
    fullVideo.play().catch(function (e) {
      console.warn('[Sahibas Reel] Full autoplay:', e);
    });

    updateDots(modalDots, index);

    // Pause mini card while modal is open
    miniVideo.pause();
    stopAutoAdvance();
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    fullVideo.pause();
    fullVideo.src = '';

    // Resume mini card
    loadMini(currentIndex);
    startAutoAdvance();
  }

  fullviewBtn.addEventListener('click', function () {
    openModal(currentIndex);
  });

  modalClose.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  /* ── MODAL NAVIGATION ── */
  function goToReel(index) {
    currentIndex = index;
    fullVideo.src = urls[index];
    fullVideo.muted = false;
    fullVideo.load();
    fullVideo.play().catch(function (e) {
      console.warn('[Sahibas Reel] Nav autoplay:', e);
    });
    updateDots(modalDots, index);
    updateDots(cardDots, index);
  }

  modalPrev.addEventListener('click', function () {
    var prev = (currentIndex - 1 + urls.length) % urls.length;
    goToReel(prev);
  });

  modalNext.addEventListener('click', function () {
    var next = (currentIndex + 1) % urls.length;
    goToReel(next);
  });

  /* ── KEYBOARD SUPPORT ── */
  document.addEventListener('keydown', function (e) {
    if (modal.style.display === 'none') return;
    if (e.key === 'Escape')      closeModal();
    if (e.key === 'ArrowLeft')   modalPrev.click();
    if (e.key === 'ArrowRight')  modalNext.click();
  });

  /* ── SWIPE SUPPORT (touch) for modal ── */
  var touchStartX = 0;
  fullVideo.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
  }, { passive: true });
  fullVideo.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) modalNext.click();
      else modalPrev.click();
    }
  }, { passive: true });

})();
